import * as React from "react";
import styled, {useTheme} from "styled-components";
import {Button, Modal} from "antd";
import {CloseOutlined} from "@ant-design/icons";

const StyledModal = styled(Modal)`
    .ant-modal-content {
        border: ${props => props.theme.borderRadius.sm} solid ${props => props.theme.colors.blue};
        box-shadow: ${props => props.theme.boxShadow.modal};
        padding: 0;
        overflow: hidden;
    }
`

const ModalTitle = styled.section`
    text-align: center;
    color: ${props => props.theme.colors.white};
    font-size: 20px;
`

const ModalCloseIcon = styled(CloseOutlined)`
    color: ${props => props.theme.colors.white};
    bottom: 4px;
    
    &&&:hover {
        color: ${props => props.theme.colors.gray};
        background: none;
    }
`

type GalleryModalProps = {
    children: React.ReactNode,
    isOpen: boolean,
    onCancel: () => void,
    footer: React.ReactNode,
    footerStyling: React.CSSProperties,
    titleContent: string
}

const GalleryModal = ({children, isOpen, onCancel, footer, footerStyling, titleContent }: GalleryModalProps) => {
    const theme = useTheme()
    return (
        <StyledModal width={700} open={isOpen} onCancel={onCancel}
                     styles={{
                header: {
                    borderRadius: 0,
                    backgroundColor: `${theme.colors.blue}`,
                    padding: "8px",
                    marginBottom: 0
                },
                footer: footerStyling
            }}
            closeIcon={<ModalCloseIcon/>}
            title={<ModalTitle>{titleContent}</ModalTitle>}
            footer={footer}
        >
            {children}
        </StyledModal>
    )
};

export default GalleryModal;
